module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/blackboard/blackboard.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/blackboard/blackboard.png
// module id = 519
// module chunks = 0